import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
  },
  header: {
    marginBottom: 30,
    alignItems: 'center',
  },
  logo: {
    width: 200,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    marginBottom: 20,
    color: '#1a365d',
    textAlign: 'center',
  },
  activitySection: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f7fafc',
    borderRadius: 5,
  },
  activityTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#2d3748',
  },
  skillTags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  tag: {
    backgroundColor: '#ebf5ff',
    color: '#2b6cb0',
    padding: '4 8',
    marginRight: 6,
    marginBottom: 4,
    borderRadius: 4,
    fontSize: 10,
  },
  instructions: {
    fontSize: 12,
    color: '#4a5568',
    lineHeight: 1.5,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    color: '#718096',
    fontSize: 10,
  },
});

const SessionPlanPDF = ({ activities }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Image
          style={styles.logo}
          src="https://images.squarespace-cdn.com/content/v1/6614c40c70aa4b22ff0a1797/a21ea81f-a463-4876-aacb-3f6f82a80c1f/Beats+%26+Bounce+Social+Logo+%281920+x+400+px%29.png"
        />
        <Text style={styles.title}>Session Plan</Text>
      </View>

      {activities.map((activity, index) => (
        <View key={index} style={styles.activitySection}>
          <Text style={styles.activityTitle}>
            {index + 1}. {activity.name}
          </Text>
          
          <View style={styles.skillTags}>
            {(typeof activity.skillTags === 'string' 
              ? activity.skillTags.split(',') 
              : activity.skillTags || []
            ).map((tag, tagIndex) => (
              <Text key={tagIndex} style={styles.tag}>
                {tag.trim()}
              </Text>
            ))}
          </View>
          
          <Text style={styles.instructions}>
            {activity.instructions}
          </Text>
        </View>
      ))}

      <Text style={styles.footer}>
        Generated by Beats & Bounce Session Planner
      </Text>
    </Page>
  </Document>
);

export default SessionPlanPDF; 